import axios from "axios";
import i18n from "@/plugins/vue-i18n";

function getBaseUrl() {
  return (window.processEnv.VUE_APP_PUBLIC_INTAKE_API_BASE_URL || "").replace(
    /\/$/,
    ""
  );
}

function getConfiguredUrl(path) {
  const baseUrl = getBaseUrl();

  if (!baseUrl) {
    throw new Error("PUBLIC_INTAKE_API_NOT_CONFIGURED");
  }

  return `${baseUrl}${path}`;
}

function post(path, payload) {
  return axios
    .post(getConfiguredUrl(path), payload, {
      headers: {
        "accept-language": i18n.locale,
      },
    })
    .then((res) => res && res.data);
}

class PublicIntakeApi {
  submitContact(payload) {
    return post("/forms/contact", payload);
  }

  submitTradeContact(payload) {
    return post("/forms/trade-contact", payload);
  }

  subscribeToNewsletter(payload) {
    return post("/newsletter/subscribe", payload);
  }
}

export default new PublicIntakeApi();
